module.exports = __webpack_public_path__ + "static/media/06.81196d73.png";